var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThFiltered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 10h3l1.78-2.226a1 1 0 0 0 .22-.625V4.3l1-.9V14c0 .6-.4 1-1 1H1c-.6 0-1-.4-1-1V2c0-.5.4-1 1-1h4.333L9 4.3V5H7v2h2v1H7v2h3Zm-4 3v-2H2v2h4Zm0-3V8H2v2h4Zm0-3V5H2v2h4Zm8 6v-2H7v2h7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.48 0c.31 0 .52.26.52.57 0 .16-.06.3-.17.41l-2.86 2.73v2.63c0 .16-.06.3-.17.41l-.82 1.1c-.1.1-.25.17-.41.17-.31 0-.57-.26-.57-.57V3.71L8.17.98A.566.566 0 0 1 8 .57c0-.31.26-.57.57-.57h6.91Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThFiltered);
export default __webpack_public_path__ + "static/media/th-filtered.49ad3a00c05eb8951254c21e55878c17.svg";
export { ForwardRef as ReactComponent };